import _regeneratorRuntime from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";

/* import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' */
import VueVirtualScroller from '@akryuminfinitum/vue-virtual-scroller';
import '@akryuminfinitum/vue-virtual-scroller/dist/vue-virtual-scroller.css';
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            Vue.use(VueVirtualScroller);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();